import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

export function usePageAnalytics(): void {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    void trackPageView(path);
  }, [location.pathname, location.search]);
}
